import { Button, Container, Divider, Paper, Typography } from "@mui/material";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <Container component={Paper} sx={{ height: 400, mt: 10 }}>
      <Typography gutterBottom variant='h3' align='center' sx={{ p: 2 }}>Page not found.</Typography>
      <Divider />
      <Button fullWidth component={Link} to='/'>Go back to book catalog</Button>
    </Container>
  )
}

export default NotFound;
